import PropTypes from 'prop-types';

export const PetTreatedPropTypes = PropTypes.shape({
  PolicyNumber: PropTypes.string,
  PetName: PropTypes.string,
  PetBreed: PropTypes.string,
  ProfilePicture: PropTypes.string,
  IsPrimaryVet: PropTypes.bool,
  FromDate: PropTypes.string,
  ToDate: PropTypes.string,
  PolicyServiceProviderLineNo: PropTypes.number
});

export const PetsTreatedPropTypes = PropTypes.arrayOf(PetTreatedPropTypes);

export const VetDetailsPropTypes = PropTypes.shape({
  VetId: PropTypes.number,
  ServiceProviderNumber: PropTypes.string,
  ServiceProviderName: PropTypes.string,
  ServiceProviderAddress: PropTypes.string,
  Suburb: PropTypes.string,
  State: PropTypes.string,
  Postcode: PropTypes.string,
  ServiceProviderContactNumber: PropTypes.string,
  EmailAddress: PropTypes.string,
  VetName: PropTypes.string,
  PetsTreated: PetsTreatedPropTypes
});
